/* eslint-disable max-len */
import React, {FC} from "react"

import BaseSvgIcon, {BaseProps} from "./Base"

const Stop: FC<BaseProps> = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 17 17">
    <g id="UX-Specification-document" stroke="none" strokeWidth="1" fillRule="evenodd">
      <g id="Homepage_default_VD_Desktop-Copy-11" transform="translate(-1108.000000, -689.000000)" fillRule="nonzero">
        <g id="Group-12" transform="translate(1091.000000, 587.000000)">
          <g id="Group-9" transform="translate(17.000000, 102.000000)">
            <g id="Stop-Survey">
              <path
                d="M8.17619048,0.0971428571 C3.70531393,0.0971428571 0.080952381,3.72150441 0.080952381,8.19238095 C0.080952381,12.6632575 3.70531393,16.287619 8.17619048,16.287619 C12.647067,16.287619 16.2714286,12.6632575 16.2714286,8.19238095 C16.2714286,6.04539032 15.4185399,3.98633483 13.9003882,2.4681832 C12.3822366,0.950031565 10.3231811,0.0971428571 8.17619048,0.0971428571 Z M15.2028571,8.19238095 C15.1939203,12.0709816 12.0440281,15.2088034 8.16542169,15.2028489 C4.28681527,15.1968944 1.14657242,12.0494159 1.14954453,8.17080608 C1.15251663,4.29219623 4.29757949,1.14953411 8.17619048,1.14952381 C12.0532178,1.15842632 15.1939546,4.29916316 15.2028571,8.17619048 L15.2028571,8.19238095 Z"
                id="Shape"
              />
              <path
                d="M11.2361905,5.11619048 C11.0288374,4.91465832 10.6987817,4.91465832 10.4914286,5.11619048 L8.17619048,7.43142857 L5.86095238,5.11619048 C5.65529206,4.91053016 5.3218508,4.91053016 5.11619048,5.11619048 C4.91053016,5.3218508 4.91053016,5.65529206 5.11619048,5.86095238 L7.43142857,8.17619048 L5.11619048,10.5238095 C4.91465832,10.7311626 4.91465832,11.0612183 5.11619048,11.2685714 C5.32676889,11.4619943 5.65037397,11.4619943 5.86095238,11.2685714 L8.17619048,8.9047619 L10.5238095,11.2361905 C10.6221015,11.3356007 10.7563958,11.3910701 10.8961905,11.39 C11.0352941,11.3876288 11.1683407,11.3326748 11.2685714,11.2361905 C11.4701036,11.0288374 11.4701036,10.6987817 11.2685714,10.4914286 L8.9047619,8.17619048 L11.22,5.86095238 C11.4261057,5.65800882 11.433282,5.32789919 11.2361905,5.11619048 Z"
                id="Shape"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </BaseSvgIcon>
)

export default Stop
